import React, { useEffect } from 'react'
import LoadingScene from '../../scenes/LoadingScene'
import { getNewCandidateProfileUrl } from '../../helpers/redirectHelpers'

const RedirectToNewProfilePage = ({ profileId }) => {
  useEffect(() => {
    window.location.replace(getNewCandidateProfileUrl(profileId))
  }, [profileId])
  return <LoadingScene />
}

export default RedirectToNewProfilePage
